wbApp.controller('clientSettingsCtrl', ['$scope', '$q', '$translate', 'tenantSettingSvc', 'notificationSvc', 'picturesSvc', '$timeout', 'messageBoxSvc',
function ($scope, $q, $translate, tenantSettingSvc, notificationSvc, picturesSvc, $timeout, messageBoxSvc) {

    const tabId = 10;
    
    var isActive = false;
    var loaded = false;
    
    $scope.onCheckboxClick = function(index) {
       for(let i = 0; i < $scope.images.length; i++) {
           $scope.images[i].checked = i === index;
       }

        $scope.tenantSetting.clientTitlePictureUrl = $scope.images[index].imageUrl;
    }
    
    $scope.newClientDesignThemeData = {};
    
    $scope.onUpdateThemeData = function() {
        let data = transformThemeDataOut($scope.newClientDesignThemeData);
        $scope.tenantSetting.newClientDesignThemeData = JSON.stringify(data);
    }
    
    function resetThemeData() {
        $scope.newClientDesignThemeData.seedColor = "#561581";
        // Primary
        $scope.newClientDesignThemeData.primary = "#561581";
        $scope.newClientDesignThemeData.onPrimary = "#FBF8FE";
        $scope.newClientDesignThemeData.primaryContainer = "#E8DAFC";
        $scope.newClientDesignThemeData.onPrimaryContainer = "#240539";
        // Secondary
        $scope.newClientDesignThemeData.secondary = "#F85830";
        $scope.newClientDesignThemeData.onSecondary = "#F9E9E8";
        $scope.newClientDesignThemeData.secondaryContainer = "#FAAB95";
        $scope.newClientDesignThemeData.onSecondaryContainer = "#B73A1C";
        // Tertiary
        $scope.newClientDesignThemeData.tertiary = "#33C236";
        $scope.newClientDesignThemeData.onTertiary = "#E8F8E8";
        $scope.newClientDesignThemeData.tertiaryContainer = "#A3E1A0";
        $scope.newClientDesignThemeData.onTertiaryContainer = "#006F00";
        // Error
        $scope.newClientDesignThemeData.error = "#D23031";
        $scope.newClientDesignThemeData.onError = "#FFEBEE";
        $scope.newClientDesignThemeData.errorContainer = "#EE9A9A";
        $scope.newClientDesignThemeData.onErrorContainer = "#B61E1D";
        // Surface
        $scope.newClientDesignThemeData.surface = "#FFFFFF";
        $scope.newClientDesignThemeData.onSurface = "#240539";
        $scope.newClientDesignThemeData.surfaceTint = "#FFFFFF";
        $scope.newClientDesignThemeData.surfaceVariant = "#FAFAFA";
        $scope.newClientDesignThemeData.outline = "#E0E0E0";

        $scope.onUpdateThemeData();
    }
    
    function transformThemeDataOut(themeData) {
        let result = {};
        for (const property in themeData) {
            result[property] = themeData[property].replace(/(#)(\w\w\w\w\w\w)$/, "$1FF$2");
        }
        return result;
    }

    function transformThemeDataIn(themeData) {
        let result = {};
        for (const property in themeData) {
            result[property] = themeData[property].replace(/(#)(\w\w)(\w\w\w\w\w\w)$/, "$1$3");
        }
        return result;
    }
    
    function loadData() {
        $scope.isBusy = true;
        $scope.tenantSetting = {};
        $scope.tenantSettingSrc = tenantSettingSvc.getAsync();
        $scope.images = picturesSvc.getDashboardImages();
        $q.all([$scope.tenantSettingSrc.$promise, $scope.images.$promise]).then(function () {
            $scope.tenantSetting = angular.copy($scope.tenantSettingSrc);
            $scope.newClientDesignThemeData = {};
            if ($scope.tenantSettingSrc.newClientDesignThemeData !== "") {
                let themeData = JSON.parse($scope.tenantSettingSrc.newClientDesignThemeData);
                $scope.newClientDesignThemeData = transformThemeDataIn(themeData);
            }
            if (!$scope.newClientDesignThemeData.seedColor) {
                resetThemeData();
            }

            $scope.tenantSettingOrig = angular.copy($scope.tenantSetting);
            
            $scope.isBusy = false;

            for(let i = 0; i < $scope.images.length; i++) {
                $scope.images[i].checked = $scope.images[i].imageUrl === $scope.tenantSetting.clientTitlePictureUrl;
            }
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === tabId) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (tenantSettingData) {

        if ($scope.isSaving) {
            return;
        }

        if (!$scope.detailIsUnchanged(tenantSettingData)) {

            $scope.isSaving = true;
            
            let tenantSettingCurrent = tenantSettingSvc.getAsync();
            tenantSettingCurrent.$promise.then(function (current) {

                // Set only fields which we do set on this tab
                current.clientTitlePictureUrl = tenantSettingData.clientTitlePictureUrl;
                current.newClientDesignThemeCode = tenantSettingData.newClientDesignThemeCode;
                if (current.newClientDesignThemeCode === 0) {
                    current.newClientDesignThemeData = tenantSettingData.newClientDesignThemeData;
                } else {
                    current.newClientDesignThemeData = "";
                }

                tenantSettingSvc.update(current, function (model) {
                    $scope.tenantSetting = angular.copy(model);
                    $scope.tenantSettingOrig = angular.copy(model);

                    $scope.isSaving = false;
                }, function (errorResult) {
                   $scope.isSaving = false;

                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));
                });
            });
        } 
    }

    $scope.detailIsUnchanged = function (tenantSettingData) {
        return angular.equals(tenantSettingData, $scope.tenantSettingOrig);
    }

    $scope.imageUpload = null;
    $scope.imageUploadError = null;
   
    let handleFileSelect = function (evt) {
        $scope.imageUpload = null;
        $scope.imageUploadError = null;
        let file = evt.currentTarget.files[0];
        if (evt.currentTarget.files[0].size > 250 * 1024) {
            $scope.$apply(function ($scope) {
                $scope.imageUploadError = $translate.instant('TXT_LBL_DASHBOARD_IMAGE_TOO_BIG');
            });
            return;
        }
        let reader = new FileReader();
        reader.onload = function (evt) {
            let img = new Image();
            img.src = evt.target.result;
            img.onload = function() {
                if (img.width !== 1920 || img.height !== 264) {
                    $scope.$apply(function ($scope) {
                        $scope.imageUploadError = $translate.instant('TXT_LBL_DASHBOARD_IMAGE_INCORRECT_SIZE');
                    });
                    
                    return;
                }
                
                $scope.$apply(function ($scope) {
                    $scope.imageUpload = evt.target.result;
                });
            };
        };
        reader.readAsDataURL(file);
    };
    
    $scope.onUploadClick = function () {
        $scope.isImageUploading = true;
        
        picturesSvc.insertDashboard($scope.imageUpload, function() {
            $scope.isImageUploading = false;
            $scope.imageUpload = null;
            $scope.imageUploadError = null;
            
            loadData();
        }, function (err) {
            $scope.isImageUploading = false;
            $scope.imageUploadError = err;
        });
    }
        
    $scope.onDeletePictureBtnClick = function(picture) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: 'TXT_TEXT_CONFIRM_DELETE_PICURE',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () { picturesSvc.remove(picture, function() {
                    loadData();
                }); }
            }]
        });
    }

    $timeout(function () {
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    }, 1000);
}]);
